import { render, staticRenderFns } from "./index-todolist.vue?vue&type=template&id=28fec32e&scoped=true&"
import script from "./index-todolist.vue?vue&type=script&lang=js&"
export * from "./index-todolist.vue?vue&type=script&lang=js&"
import style0 from "./index-todolist.vue?vue&type=style&index=0&id=28fec32e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fec32e",
  null
  
)

export default component.exports